import { sdkRequest } from '@eventbrite/http';

export const checkEbAdsEventEligibility = async (eventId: string) => {
    try {
        const isAuthed = window.__SERVER_DATA__?.user.isAuthenticated;
        if (!isAuthed) return;

        const url = `/api/v3/promoted_content/organizations/eb-ads-event-eligible/${eventId}`;

        const data = await sdkRequest(url);

        return data;
    } catch (error) {
        return null;
    }
};
